export default "__VITE_ASSET__4d1e585e__"